<template>
    <div class="base-pwd-pay-modify" :class="{'pwdpaymod-sp': $store.state.screen == 1}">
        <div class="content">
            <div v-show="isRetrieve == 0">
                <div class="title">修改支付密码</div>
                <div>
                    <input class="val" type="text" maxlength="16" placeholder="请输入原密码" v-model="oldPwd" />
                    <input class="val" type="text" maxlength="16" placeholder="设置新密码（6~16位数字或字母）" v-model="newPwd" />
                    <input class="val" type="text" maxlength="16" placeholder="再次确认新密码" v-model="confirmPwd" />
                </div>
                <div class="btn">
                    <div class="item" @click="onOut">取消</div>
                    <div class="item" @click="submit">确定</div>
                </div>
                <div class="footer">
                    <div class="footer-btn" @click="onRetrieve">找回支付密码</div>
                    <div class="footer-btn" @click="onReset">清除支付密码</div>
                </div>
            </div>
            <div v-show="isRetrieve == 1">
                <div class="title">找回支付密码</div>
                <div class="tips">为了您的账号安全，需验证已绑定的手机{{phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}}</div>
                <div>
                    <div class="val-box">
                        <input class="phonecode" type="text" maxlength="6" placeholder="请输入验证码" v-model="getCode" />
                        <div class="code" @click="onCode(4)" v-if="iscode == false">获取验证码</div>
                        <div class="code" v-if="iscode == true">{{count}}s</div>
                    </div>
                    <input class="val" type="text" maxlength="16" placeholder="设置新密码（6~16位数字或字母）" v-model="getPwd" />
                    <input class="val" type="text" maxlength="16" placeholder="再次确认新密码" v-model="getConPwd" />
                </div>
                <div class="btn">
                    <div class="item" @click="onCancel">取消</div>
                    <div class="item" @click="getPwdSubmit">确定</div>
                </div>
            </div>
            <div v-show="isRetrieve == 2">
                <div class="title">验证手机号</div>
                <div class="tips">为了您的账号安全，需验证已绑定的手机{{phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}}</div>
                <div class="val-box">
                    <input class="phonecode" type="text" maxlength="6" placeholder="请输入验证码" v-model="yzCode" />
                    <div class="code" @click="onCode(6)" v-if="iscode == false">获取验证码</div>
                    <div class="code" v-if="iscode == true">{{count}}s</div>
                </div>
                <div class="btn">
                    <div class="item" @click="onCancel">取消</div>
                    <div class="item" @click="onNext">下一步</div>
                </div>
            </div>
            <div v-show="isRetrieve == 3">
                <div class="title">清除支付密码</div>
                <div class="tips">支付密码用于游戏内使用平台币消费时所需的密码。你确定要清除现有的支付密码？</div>
                <div class="btn">
                    <div class="item" @click="onCancel">取消</div>
                    <div class="item" @click="delSubmit">确定</div>
                </div>
            </div>
            <transition name="component-fade" mode="out-in">
                <TheTips :msg='msg' v-if="msg" />
            </transition>
        </div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        props: {
            phone: String
        },
        data () {
            return {
                msg: null,
                isRetrieve: 0, // 0修改支付密码，1找回支付密码，2验证手机号，3清除支付密码
                oldPwd: '',
                newPwd: '',
                confirmPwd: '',
                getCode: '',
                yzCode: '',
                getPwd: '',
                getConPwd: '',
                iscode: false,
                count: 59,
                accountData: {}
            }
        },
        methods: {
            // 关闭弹窗
            onOut () {
                this.$emit('childPayModify', null)
            },
            // 获取验证码
            onCode (id) {
                if (this.iscode == true) {
                    return false
                }
                let options = {
                    appid: this.accountData.appid, //应用ID
                    mobile: this.phone,
                    type: id //1 注册 2绑定 3解绑 4 找回密码 6 换绑
                };
                options.sign = this.util.getSign(options, this.accountData.appkey);
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=send_message', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.iscode = true
                        this.count = 59
                        let time = setInterval(() => {
                            this.count--
                            if (this.count == 0) {
                                clearInterval(time)
                                this.iscode = false
                            }
                        }, 1000)

                        this.msg = '验证码已发送'
                        setTimeout(() => {
                            this.msg = null
                        }, 1000)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 修改支付密码
            submit () {
                // 数字或字母正则
                // let reg = /^[0-9a-zA-Z]*$/g
                if (this.newPwd.replace(/\s*/g, "") || this.confirmPwd.replace(/\s*/g, "")) {
                    if (this.newPwd.replace(/\s*/g, "").length >= 6 || this.confirmPwd.replace(/\s*/g, "").length >= 6) {
                        if (this.newPwd.replace(/\s*/g, "") == this.confirmPwd.replace(/\s*/g, "")) {
                            let options = {
                                uid: this.accountData.uid,
                                appid: this.accountData.appid,
                                channel: this.accountData.channel?this.accountData.channel:1,
                                system: this.config.system,
                                old_pay_password: this.oldPwd,
                                pay_password: this.newPwd
                            }
                            options.sign = this.util.getSign(options, this.accountData.appkey)
                            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=modify_pay_pass',this.$qs.stringify(options)).then(res => {
                                if (res.data.status == 1) {
                                    this.msg = '修改成功'
                                    setTimeout(() => {
                                        this.msg = null
                                        this.$emit('childPayModify', null)
                                    }, 1000)
                                } else {
                                    this.msg = res.data.msg
                                    setTimeout(() => {
                                        this.msg = null
                                    }, 2000)
                                }
                            }).
                            catch(o => {
                                this.msg = '请求失败'
                                setTimeout(() => {
                                    this.msg = null
                                }, 2000)
                            })
                        } else {
                            this.msg = '两次密码输入不一致'
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    } else {
                        this.msg = '密码长度为6到16位'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }
            },
            // 找回支付密码
            getPwdSubmit () {
                // 数字或字母正则
                // let reg = /^[0-9a-zA-Z]*$/g
                if (!this.getCode.replace(/\s*/g, "")) {
                    this.msg = '请输入验证码'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if (this.getPwd.replace(/\s*/g, "") || this.getConPwd.replace(/\s*/g, "")) {
                    if (this.getPwd.replace(/\s*/g, "").length >= 6 || this.getConPwd.replace(/\s*/g, "").length >= 6) {
                        if (this.getPwd.replace(/\s*/g, "") == this.getConPwd.replace(/\s*/g, "")) {
                            let options = {
                                uid: this.accountData.uid,
                                appid: this.accountData.appid,
                                channel: this.accountData.channel,
                                system: this.config.system,
                                code: this.getCode,
                                mobile: this.phone,
                                pay_password: this.getPwd
                            }
                            options.sign = this.util.getSign(options, this.accountData.appkey)
                            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=get_pay_pass',this.$qs.stringify(options)).then(res => {
                                if (res.data.status == 1) {
                                    this.msg = '找回成功'
                                    setTimeout(() => {
                                        this.msg = null
                                        this.$emit('childPayModify', null)
                                    }, 1000)
                                } else {
                                    this.msg = res.data.msg
                                    setTimeout(() => {
                                        this.msg = null
                                    }, 2000)
                                }
                            }).
                            catch(o => {
                                this.msg = '请求失败'
                                setTimeout(() => {
                                    this.msg = null
                                }, 2000)
                            })
                        } else {
                            this.msg = '两次密码输入不一致'
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    } else {
                        this.msg = '密码长度为6到16位'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }
            },
            // 清除支付密码
            delSubmit () {
                let options = {
                    uid: this.accountData.uid, //应用ID
                    appid: this.accountData.appid,
                    channel: this.accountData.channel,
                    system: this.config.system,
                    code: this.yzCode,
                    mobile: this.phone
                };
                options.sign = this.util.getSign(options, this.accountData.appkey);
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=del_pay_pass', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.msg = '清除成功'
                        setTimeout(() => {
                            this.msg = null
                            this.$emit('childPayModify', null)
                        }, 1000)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            onRetrieve () {
                this.isRetrieve = 1
            },
            onReset () {
                this.isRetrieve = 2
                this.iscode = false
            },
            onCancel () {
                this.isRetrieve = 0
            },
            onNext () {
                if (!this.yzCode.replace(/\s*/g, "")) {
                    this.msg = '请输入验证码'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                this.verifyPhone()
            },
            // 验证手机号
            verifyPhone () {
                let options = {
                    uid: this.accountData.uid,
                    mobile: this.phone,
                    appid: this.accountData.appid, //应用ID
                    code: this.yzCode
                };
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=mobile_verify', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.isRetrieve = 3
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-pwd-pay-modify {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .tips {
                font-size: 42px;
                margin-bottom: 50px;
            }
            .val-box {
                width: 100%;
                height: 120px;
                color: #fff;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                margin-bottom: 30px;
                display: flex;
                align-items: center;
                .phonecode {
                    width: 477px;
                    height: 48px;
                    color: #fff;
                    font-size: 39px;
                    border: 0;
                    border-right: 3px solid #fff;
                    border-radius: 18px 0 0 18px;
                    background: transparent;
                    padding: 0 45px;
                    outline: none;
                }
                .code {
                    flex: 1;
                    font-size: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .val {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                border: 0;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin-bottom: 30px;
                outline: none;
            }
            .val:last-child {
                margin-bottom: 0;
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
            .footer {
                height: 32px;
                margin: 44px 0 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .footer-btn {
                    width: 50%;
                    font-size: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .footer-btn:first-child {
                    border-right: 2px solid rgba(255, 255, 255, 0.2);
                }
            }
        }
    }
    // 竖屏css
    .pwdpaymod-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .tips {
                font-size: 76px;
                margin-bottom: 90px;
            }
            .val-box {
                height: 200px;
                border-radius: 32px;
                margin-bottom: 54px;
                .phonecode {
                    width: 867px;
                    height: 87px;
                    font-size: 70px;
                    border-right: 5px solid #fff;
                    border-radius: 32px 0 0 32px;
                    padding: 0 81px;
                }
                .code {
                    font-size: 65px;
                }
            }
            .val {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
                margin-bottom: 54px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
            .footer {
                height: 58px;
                margin: 80px 0 0;
                .footer-btn {
                    font-size: 60px;
                }
                .footer-btn:first-child {
                    border-right: 3px solid rgba(255, 255, 255, 0.2);
                }
            }
        }
    }
</style>